import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { getSessionStorage } from "@jti/rest-api";
import { useDispatch, useSelector } from "@jti/store";
import { useLoyaltyStatus } from "../../hooks/useLoyaltyStatus";
import { usePrice } from "../../hooks/usePrice";
import { PaymentSummary } from "../PaymentSummary/PaymentSummary";
import { SummaryLoyaltyPoints } from "../SummaryLoyaltyPoints";
const sessionStorage = getSessionStorage();
export const CartPaymentSummary = ({ showLoyaltyPointsSummary = false }) => {
    const dispatch = useDispatch();
    const isLoyaltyActive = useLoyaltyStatus();
    const { loyaltyChoice } = useSelector((store) => store.loyalty);
    const { cartId, prices, pricesFetchStatus, fetchCurrentPrices } = usePrice(undefined, true);
    const cartPoints = sessionStorage.get("loyaltyCartPoints", 0);
    useEffect(() => {
        if (cartId && pricesFetchStatus === "idle") {
            // @ts-expect-error - TS doesn't know that fetchCurrentPrices. Depending on isFreeTrial, it will be either fetchPrices or fetchTrialsPrices used directly is not causing problems
            dispatch(fetchCurrentPrices(cartId));
        }
    }, [cartId, pricesFetchStatus]);
    if (pricesFetchStatus === "idle") {
        return null;
    }
    return (_jsx(PaymentSummary, { isPricesLoading: pricesFetchStatus === "pending", prices: prices, children: showLoyaltyPointsSummary && isLoyaltyActive ? (_jsx(SummaryLoyaltyPoints, { hasLoyalty: isLoyaltyActive, totalLoyaltyPoints: cartPoints, loyaltyChoice: loyaltyChoice || 0 })) : null }));
};
//# sourceMappingURL=CartPaymentSummary.js.map